import { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router'
import { getSearchParams, getUrlParams } from 'shared/utils/getUrlParams'

export const getQuery = (): URLSearchParams => {
  if (typeof window !== 'undefined') {
    return new URLSearchParams(getSearchParams())
  }
  return new URLSearchParams()
}

type type = {
  [key: string]: string
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getUpdateUrl = (newVal: type, navigate: any): void => {
  const query = Object.keys(newVal)?.length ? getQuery() : new URLSearchParams()
  for (const key in newVal) {
    if (newVal?.[key]?.trim() !== '') {
      query.set(key, newVal?.[key])
    } else {
      query.delete(key)
    }
  }
  if (typeof window !== 'undefined') {
    const hash = window.location.hash.split('?')[0]
    // return `${hash}?${query}`
    navigate(`${hash}?${query}`)
    const event = new CustomEvent(DispatchQuery)
    document.dispatchEvent(event)
  }
}

const useQueryParams = (defaultVal?: type): [type, (val: type) => void] => {
  const [query, setQuery] = useState(defaultVal || getUrlParams())

  const navigate = useNavigate()

  const updateUrl = (newVal: type) => {
    setQuery(newVal)
    getUpdateUrl(newVal, navigate)
  }

  return [query, updateUrl]
}

export const useQuery = (defaultVal?: type): [type, (val: type) => void] => {
  const [, setParams] = useQueryParams(defaultVal)
  const location = useLocation()

  const [allValues, setAllValues] = useState<type>(
    Object.fromEntries(getQuery())
  )

  useEffect(() => {
    setAllValues(Object.fromEntries(getQuery()))
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [location])

  return [allValues, setParams]
}

export const DispatchQuery = 'dispatchQwery'
